import React from 'react';

const ChevronDownIcon = (props) => {
  return <div {...props}>
    <img src={require('../../assets/chevron-down.svg')} />
  </div>
}

export default ChevronDownIcon
